var map = {
	"./Asset 11.svg": 3018,
	"./Asset 12.svg": 6830,
	"./Asset 13.svg": 6790,
	"./Asset 14.svg": 9171,
	"./Asset 15.svg": 4819,
	"./Asset 16.svg": 3213,
	"./Asset 3.svg": 5980,
	"./Asset 4.svg": 4811,
	"./Asset 5.svg": 7223,
	"./Asset 6.svg": 2980,
	"./Asset 7.svg": 2363,
	"./Asset 8.svg": 5720,
	"./Asset 9.svg": 9798,
	"./android-store.svg": 313,
	"./android-store_1.svg": 888,
	"./apple-store.svg": 6977,
	"./apple-store_1.svg": 378,
	"./check-mark.svg": 1574,
	"./facebook.svg": 219,
	"./huawei-store.svg": 4843,
	"./huawei-store_1.svg": 8516,
	"./icon-magnifying-glass.svg": 5119,
	"./instagram.svg": 8127,
	"./it.svg": 7089,
	"./linkedin.svg": 6422,
	"./paper-plane-icon.svg": 4763,
	"./popravka_montaza.svg": 2158,
	"./transport_selidbe.svg": 7437,
	"./trophy-icon.svg": 5798,
	"./youtube.svg": 6633,
	"./zdrastvo_njega.svg": 1230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 772;